import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/borders.css';
import { i18nReady } from './i18n';
import App from './App';

// Debug: log app start
console.log('[BOOT] React app starting', { hash: window.location.hash, href: window.location.href });

// Global error handler to catch crashes
window.onerror = (msg, source, line, col, error) => {
  console.error('[CRASH]', msg, source, line, col, error);
  // Show visible error on screen
  const el = document.createElement('div');
  el.style.cssText = 'position:fixed;top:0;left:0;right:0;background:#e04848;color:#fff;padding:12px;z-index:99999;font-family:monospace;font-size:12px;';
  el.textContent = `[CRASH] ${msg} at ${source}:${line}`;
  document.body.appendChild(el);
};

window.onunhandledrejection = (e) => {
  console.error('[UNHANDLED]', e.reason);
};

const root = ReactDOM.createRoot(document.getElementById('root'));

// Wait for i18n translations to load before rendering
console.log('[BOOT] Waiting for i18n...');
i18nReady.then(() => {
  console.log('[BOOT] i18n ready, rendering App');
  root.render(<App />);
}).catch(err => {
  console.error('[BOOT] i18n failed', err);
});
